(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  var recommendationsUrl = new URL(productRecommendationsSection.dataset.url, window.location.origin);
  var currentParams = new URLSearchParams(window.location.search);
  if (currentParams.has("preview_theme_id")) {
    recommendationsUrl.searchParams.set("preview_theme_id", currentParams.get("preview_theme_id"));
  }
  request.open("GET", recommendationsUrl.toString());
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var incomingRecommendations = container.querySelector(".related-products");
      if (!incomingRecommendations) { return; }

      // Amir Boutique: old Symmetry colour/size rows can be returned by a
      // cached/published recommendation response while previewing a new theme.
      // Remove them before inserting the recommendation cards so only the
      // premium quick-add size selector remains.
      incomingRecommendations.querySelectorAll(".product-block-options").forEach(function(el) {
        el.remove();
      });

      productRecommendationsSection.innerHTML = incomingRecommendations.innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
